import { Status } from '@vendasta/sales-orders';

export interface Badge {
  text: string;
  color: string;
}

const statusMap = new Map<Status, string>([
  [Status.SUBMITTED, 'Submitted'],
  [Status.RESUBMITTED, 'Resubmitted'],
  [Status.APPROVED, 'Approved'],
  [Status.DECLINED, 'Declined'],
  [Status.DRAFTED, 'Drafted'],
  [Status.FULFILLED, 'Activated'],
  [Status.PROCESSING, 'Processing'],
  [Status.ACTIVATION_ERRORS, 'Activation errors'],
  [Status.ARCHIVED, 'Archived'],
  [Status.SUBMITTED_FOR_CUSTOMER_APPROVAL, 'Awaiting customer approval'],
  [Status.CANCELLATION_REQUESTED, 'Cancellation requested'],
  [Status.CANCELLED, 'Cancelled'],
  [Status.SCHEDULED_ACTIVATION, 'Scheduled activation'],
]);

const statusColorMap = new Map<Status, string>([
  [Status.APPROVED, 'green'],
  [Status.RESUBMITTED, 'blue'],
  [Status.DECLINED, 'light-gray'],
  [Status.FULFILLED, 'blue'],
  [Status.PROCESSING, 'yellow'],
  [Status.ACTIVATION_ERRORS, 'red'],
  [Status.ARCHIVED, 'blue-solid'],
  [Status.CANCELLED, 'red'],
  [Status.SCHEDULED_ACTIVATION, 'yellow'],
]);

// taken from partner-center-client TODO: like to move this into frontend sales-ui
export function badgeWithOrderStatus(status: Status): Badge {
  const text = statusMap.get(status) ? statusMap.get(status).split('_').join(' ') : 'Pending';
  const color = statusColorMap.get(status) ? statusColorMap.get(status) : 'gray';
  return { text: text, color: color };
}
